import React from 'react'
import './details.css'
import Card  from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import {AiOutlineStar} from 'react-icons/ai' 
import {MdVideoLibrary} from 'react-icons/md'

function Details({currentMovie, play}) {
    const {original_title, videos, poster_path, release_date, vote_average, overview
    } = currentMovie;
    const average = Math.round(vote_average * 10)/10
    const imgUrl = 'https://image.tmdb.org/t/p/w500/';
  return (
    <div className='detail'>
    <Card className='card-detail'>
      <CardMedia component="img"
        image={`${imgUrl+poster_path}`} alt={original_title} />
    </Card>
      <h4 className='detail-title'>{original_title}</h4>
      <div className='info'>
        <div className='info-name'>
          <p>{release_date}</p>
          <p><AiOutlineStar />{average}</p>
        </div>
        <button className='infos-btn' onClick={play}><MdVideoLibrary/> Trailer</button>
      </div>
    <div>
      <p>{overview}</p>
    </div>
    </div>
  )
}

export default Details